"use client";
import React, { useEffect, useState } from "react";
import Header from "./header/Header";
import Footer from "./footer/Footer";
import dynamic from "next/dynamic";
import { Toaster } from "react-hot-toast";
import PlanExpired from "@/components/common-components/plan-expired";
import { Email, PhoneIcon, PhoneRing, WhatsAppIcon } from "@/utlility/icons";
import Link from "next/link";
import "./index.css"
const CustomModal = dynamic(() => import("../common-components/CustomModal"), { ssr: false });

import { fetchNavigationData, fetchSettingData } from "@/utlility/api-helpers";

import { useSelector } from "react-redux";

const Layout = ({ children, initialLogo, whatsapp = null,phoneNumber=null }) => {
  const { headerData: reduxHeaderData, featuresData: reduxFeaturesData } = useSelector((state) => state?.organization);

  const [navigationData, setNavigationData] = useState(reduxFeaturesData);
  const [headerData, setHeaderData] = useState(reduxHeaderData);
  const [openModal, setOpenModal] = useState(false);

  useEffect(() => {
    // Only fetch if Redux doesn't have the data (initial hydration failed or was skipped)
    if (!reduxFeaturesData || !reduxHeaderData) {
      const loadData = async () => {
        const [navResult, settingResult] = await Promise.all([
          fetchNavigationData(),
          fetchSettingData()
        ]);

        if (navResult) setNavigationData(navResult);
        if (settingResult) setHeaderData(settingResult);
      };
      loadData();
    }
  }, [reduxFeaturesData, reduxHeaderData]);

  const currentHeaderData = reduxHeaderData || headerData;
  const currentNavigationData = reduxFeaturesData || navigationData;

  if (currentHeaderData?.plan_status === "expired") {
    return <PlanExpired />;
  }

  return (
    <div className="overflow-y-auto main-cover">
      <Toaster position="top-right" reverseOrder={false} />
      <Header initialLogo={initialLogo} navigationData={currentNavigationData} />
      <main className="z-1">{children}</main>
      <Footer initialLogo={initialLogo} />
      {phoneNumber && (
        <Link
          aria-label="Call on"
          className="position-fixed call-btn rounded-circle border-0 icon"
          href={`tel:${phoneNumber}`}
          target="_blank"
        >
          <PhoneIcon size={24} />
        </Link>
      )}
      {whatsapp && (
        <Link
          aria-label="Chat on WhatsApp"
          className="position-fixed whats-app-btn rounded-circle border-0 icon"
          href={`https://wa.me/${whatsapp}`}
          target="_blank"
        >
          <WhatsAppIcon size={24} />
        </Link>
      )}
      <button
        onClick={() => setOpenModal(true)}
        className="position-fixed get-in-touch-btn rounded-circle border-0 icon"
        aria-label="Get in Touch"
      >
        <Email color="#BED643" />
      </button>
      {openModal && <CustomModal show={openModal} onHide={() => setOpenModal(false)} />}
    </div>
  );
};

export default Layout;

